/**
 * Что значит тап по карте — в зависимости от режима вьюера.
 *
 * Режимы «укажите точку» (отметка опасности персоналом — staff-hazard-sheet.tsx,
 * замер CAD — measure-bar.tsx) забирают тап целиком: выбор цели маршрута в них
 * не срабатывает ни по помещению, ни по маркеру POI. Порядок важен: отметка
 * опасности главнее замера — это действие сотрудника в обстановке ЧС.
 * Чистая функция без сигналов — проверяется в tap-mode.test.ts.
 */
import type { LonLat } from '@app/geo'
import type { MapTap } from './map/map-taps'

export interface TapModes {
  /** Сотрудник нажал «Поставить на карте» (state.hazardPickMode). */
  readonly hazardPick: boolean
  /** Включён замер расстояний (state.measureActive). */
  readonly measure: boolean
}

export type MapTapAction =
  | { readonly kind: 'hazard-point'; readonly lngLat: LonLat }
  | { readonly kind: 'measure-point'; readonly lngLat: LonLat }
  | { readonly kind: 'select'; readonly id: string }
  | { readonly kind: 'none' }

/** Карта ждёт точку: тапы слоёв (укрытия, этажерка) и выбор цели молчат. */
export function isPointMode(modes: TapModes): boolean {
  return modes.hazardPick || modes.measure
}

export function resolveMapTap(tap: MapTap, modes: TapModes): MapTapAction {
  if (modes.hazardPick) return { kind: 'hazard-point', lngLat: tap.lngLat }
  if (modes.measure) return { kind: 'measure-point', lngLat: tap.lngLat }
  return tap.featureId ? { kind: 'select', id: tap.featureId } : { kind: 'none' }
}
